/**
 *
 * CreateUpdateDetails
 *
 */

import React, { memo } from 'react';

import styled from 'styled-components/macro';
import { Profile } from '../Profile';

import { ChangePassword } from '../ChangePassword';
import { ActiveSessions } from '../ActiveSessions';
import { Button } from 'core/components/Button';
import { useSearchParams } from 'react-router-dom';
import { ReactComponent as Back } from 'assets/icons/LeftArrow.svg';


interface Props {
    moduleName: string;
    moduleKey: number;
}

export const CreateUpdateDetails = memo((props: Props) => {

    const [searchParams, setSearchParams] = useSearchParams();

    const ModuleDisplay = () => {
        switch (props.moduleKey) {
            case 0:
                return <Profile action='update' />;
            case 1:
                return <ChangePassword />;
            case 2:
                return <ActiveSessions />;
        }
    };

    return (
        <Div className="w-full min-h-max bg-white rounded-xl shadow-xl px-[2vw] py-[1.5vw]">
            <div className="flex flex-col">
                <div className="flex">
                    {![0, 1, 2].includes(props.moduleKey) && (
                        <Button
                            type="white"
                            width="w-fit h-fit"
                            padding="p-0 mr-[1%]"
                            onClick={() => {
                                searchParams.set('action', 'list');
                                //   if (props.moduleKey !== 11) {
                                //     searchParams.delete('id');
                                //   }
                                setSearchParams(searchParams);
                            }}
                            icon={
                                <Back
                                    className="font-bold text-2xl w-[1.8vw] h-[1.8vw] relative top-[0.2vh] rounded-full hover:bg-primary-10 text-primary-main mr-[1%] cursor-pointer"
                                    stroke="#5E4DE0"
                                />
                            }
                        />
                    )}

                    <h1 className="font-bold text-2xl text-primary-main mb-[2vh]">
                        {props.moduleKey === 2 ? props.moduleName : `Create ${props.moduleName}`}
                    </h1>
                </div>
            </div>
            {ModuleDisplay()}
        </Div>
    );
});

const Div = styled.div``;
